import Vue from 'vue';
import Router from 'vue-router'

Vue.use(Router);



const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'Main',
    },
    {
        path: '/country/:name',
        name: 'Country',
    }
  ]
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js